import React, { useEffect, useState } from 'react';
import MediaViewer from '../../../../shared/media-viewer/MediaViewer';
import { useSelector } from 'react-redux';
import { SELECT_ICON, AUDIENCE_TYPE_OPTIONS } from '../../../../constants/ActivityCalendarConst';
import moment from 'moment';
import { EMPTY_PLACEHOLDER } from '../../../../utils/Constants';
import LocationViewTab from '../../../../shared/location-view-tab/Location-View-Tab';
import CustomPhoneNoView from '../../../../shared/custom-PhoneNoView/CustomPhoneNoView';
import RedirectUrlLink from '../../../../shared/redirect-url-link/Redirect-Url-Link';
import { selectedHotelCurrencySelector } from '../../../property/propertySlice';
import { currencies } from '../../../../constants/Currencies';
import CustomImageViewer from '../../../../shared/custom-image-viewer/Custom-Image-Viewer';

const ActivityCalendarCetails = ({ tabValue, activityData, getAlllocationData }) => {
  const [tagList, setTagList] = useState([]);
  const [icons, setIcons] = useState([]);

  const [scheduleValue, setScheduleValue] = useState({
    startTime: '',
    endTime: '',
    startDate: '',
    endDate: '',
  });

  const activityType = useSelector(({ cms }) => cms?.activityTagsList);

  useEffect(() => {
    if (activityData) {
      setTagList(activityType.filter((tag) => activityData?.tags?.includes(tag.id)));
      setIcons(
        Array.isArray(activityData?.icons)
          ? SELECT_ICON?.filter((ic) => activityData?.icons?.includes(ic?.id))
          : [],
      );
      hanldeSetScheduleValue();
    } else {
      setTagList([]);
      setIcons([]);
      setScheduleValue({
        timeSlots: [],
        startDate: '',
        endDate: '',
      });
    }
  }, [activityType, activityData]);

  const hanldeSetScheduleValue = () => {
    if (!activityData?.schedule) {
      setScheduleValue({
        timeSlots: [],
        startDate: '',
        endDate: '',
      });
      return;
    }
    const { scheduleType, oneTime, recurring, startTime, endTime } = activityData?.schedule;
    let startDate = '',
      endDate = '',
      timeSlots = [];

    if (scheduleType === 'ONE_TIME') {
      startDate = moment(oneTime?.date, 'DD-MM-YYYY').format('DD MMM,YYYY');
      timeSlots = [
        {
          startTime: startTime,
          endTime: endTime,
        },
      ];
    } else if (scheduleType === 'RECURRING') {
      startDate = moment(recurring?.startDate, 'DD-MM-YYYY').format('DD MMM,YYYY');
      endDate = moment(recurring?.endDate, 'DD-MM-YYYY').format('DD MMM,YYYY');
      timeSlots = recurring?.recurringTimeSlots || [];
    }
    setScheduleValue({
      timeSlots,
      startDate,
      endDate,
    });
  };
  const currencyCode = useSelector(selectedHotelCurrencySelector);
  const matchedCurrency = currencies?.filter((item) => item?.code === currencyCode);

  const setInfoView = (info) => {
    if (info.email) return info.email;
    if (info.phone) return <CustomPhoneNoView value={info.phone} />;
    if (info.URL) return <RedirectUrlLink url={info.URL} />;
  };

  const SCHEDULE_TYPE_LABELS = {
    RECURRING: 'Recurring',
    ONE_TIME: 'One Time',
    ALWAYS_ACTIVE: 'Always Active',
  };

  const getOrdinalSuffix = (num) => {
    const j = num % 10,
      k = num % 100;
    if (k >= 11 && k <= 13) {
      return num + 'th';
    }
    switch (j) {
      case 1:
        return num + 'st';
      case 2:
        return num + 'nd';
      case 3:
        return num + 'rd';
      default:
        return num + 'th';
    }
  };

  const formatDateWithOrdinal = (dateStr) => {
    if (!dateStr) return EMPTY_PLACEHOLDER;
    const date = moment(dateStr, 'DD-MM-YYYY');
    const dayWithSuffix = getOrdinalSuffix(date.date());
    const month = date?.format('MMM');
    const year = date?.format('YYYY');
    return `${dayWithSuffix} ${month}, ${year}`;
  };

  const renderMinimumAge = (value) => {
    if (value === 0 || value === '0') return '---';
    if (value === null || value === undefined || value === '') return EMPTY_PLACEHOLDER;
    return value;
  };

  return (
    <div className='row mx-4 mt-4'>
      {tabValue === 0 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Activity name</div>
            <div className='details-value preview-breaks'>{activityData?.name} </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Category</div>
            <div className='details-value'>{activityData?.categoryName} </div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Description</div>
            <div className='details-value'>{activityData?.description}</div>
          </div>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Highlights</div>
            <div className='details-value'>
              {activityData?.highlights ? activityData?.highlights : EMPTY_PLACEHOLDER}
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Price</div>
            <div className='details-value'>
              {activityData?.price
                ? `${matchedCurrency?.[0]?.symbol || ''} ${activityData?.price}`
                : EMPTY_PLACEHOLDER}
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Tags</div>
            <div className='details-value'>{tagList?.map((tag) => tag?.name).join(',')}</div>
          </div>
          {/* Participant Type */}
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Participant Type</div>
            <div className='details-value'>
              {activityData?.forChild ? 'For Child' : 'For Adult'}
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Minimum Age</div>
            <div className='details-value'>{renderMinimumAge(activityData?.minimumAge)}</div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Gender</div>
            <div className='details-value'>
              {Array.isArray(activityData?.gender) && activityData?.gender.length
                ? activityData.gender.join(', ')
                : EMPTY_PLACEHOLDER}
            </div>
          </div>

          <div className='col-md-6 mt-4'>
            <div className='details-label'>Availability</div>
            <div className='details-value'>
              {activityData?.residentsOnly === true ? 'Residents Only' : 'Open to All'}
            </div>
          </div>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>Icons</div>
            <div className='details-value'>
              {icons?.length > 0 ? (
                icons.map((ic) => (
                  <span key={ic?.id} className='me-3'>
                    <img src={ic?.url} alt={ic?.name} className='me-1' width='20' height='20' />
                    {ic?.name}
                  </span>
                ))
              ) : (
                EMPTY_PLACEHOLDER
              )}
            </div>
          </div>

          <div className='col-md-6 mt-4'>
            <div className='details-label'>Capacity</div>
            <div className='details-value'>{activityData?.capacity ?? EMPTY_PLACEHOLDER}</div>
          </div>
        </>
      )}
      {tabValue === 1 && (
        <>
          {activityData?.activityLocation?.locationType === 'URL' && (
            <>
              <div className='col-md-12 mt-4'>
                <div className='details-label'>Location Type</div>
                <div className='details-value'>
                  {activityData?.activityLocation?.locationType === 'URL' ? 'On Web' : ''}
                </div>
              </div>

              <div className='col-md-12 mt-4'>
                <div className='details-label'>URL Title</div>
                <div className='details-value'>{activityData?.activityLocation?.urlTitle}</div>
              </div>

              <div className='col-md-12 mt-4'>
                <div className='details-label'>URL</div>
                <div className='details-value'>{activityData?.activityLocation?.url}</div>
              </div>
            </>
          )}

          {activityData?.activityLocation?.locationType === 'HOTEL' && (
            <>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>Location Type</div>
                <div className='details-value'>{activityData?.activityLocation?.locationType}</div>
              </div>

              <div className='col-md-12 mt-4'>
                <div className='details-label'>Location</div>
                <div className='details-value'>
                  {getAlllocationData?.find(
                    (item) => item?.id === activityData?.activityLocation?.hotelLocation,
                  )?.name || EMPTY_PLACEHOLDER}
                </div>
              </div>
            </>
          )}
          {activityData?.activityLocation?.locationType === 'EXTERNAL' && (
            <LocationViewTab location={activityData?.activityLocation} />
          )}
        </>
      )}

      {tabValue === 2 && (
        <>
          <div className='col-md-12 mt-4'>
            <div className='details-label'>Schedule Type</div>
            <div className='details-value'>
              {SCHEDULE_TYPE_LABELS[activityData?.schedule?.scheduleType] ||
                activityData?.schedule?.scheduleType}
            </div>{' '}
          </div>
          {activityData?.schedule?.scheduleType === 'RECURRING' && (
            <div className='col-md-12 mt-4'>
              <div className='details-label'>Recurs Every</div>
              <div className='details-value'>
                {activityData?.schedule?.recurring?.recurs?.charAt(0)?.toUpperCase() +
                  activityData?.schedule?.recurring?.recurs?.slice(1)?.toLowerCase()}
                {activityData?.schedule?.recurring?.recurs === 'WEEK' &&
                  `( ${activityData?.schedule?.recurring?.recursWeek
                    ?.map((day) => day?.charAt(0)?.toUpperCase() + day?.slice(1)?.toLowerCase())
                    ?.join(', ')})`}
                {activityData?.schedule?.recurring?.recurs === 'MONTH' &&
                  `( ${activityData?.schedule?.recurring?.dates[0]
                    ?.split(',')
                    ?.map((date) => getOrdinalSuffix(Number(date?.trim())))
                    ?.join(', ')})`}
              </div>
            </div>
          )}
          {!activityData?.schedule?.alwaysActive && (
            <div className='row'>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>
                  {activityData?.schedule?.scheduleType === 'ONE_TIME' ? 'Date' : 'Start Date'}
                </div>
                <div className='details-value'>
                  {activityData?.schedule?.scheduleType === 'ONE_TIME'
                    ? formatDateWithOrdinal(activityData?.schedule?.oneTime?.date)
                    : formatDateWithOrdinal(activityData?.schedule?.recurring?.startDate)}
                </div>
              </div>
              {activityData?.schedule?.scheduleType === 'RECURRING' && (
                <div className='col-md-6 mt-4'>
                  <div className='details-label mt-1'>End Date</div>
                  <div className='details-value'>
                    {formatDateWithOrdinal(activityData?.schedule?.recurring?.endDate)}
                  </div>
                </div>
              )}
            </div>
          )}
          {activityData?.schedule?.scheduleType === 'ALWAYS_ACTIVE' ? (
            <></>
          ) : (
            <div className='row'>
              {scheduleValue?.timeSlots?.length > 0 ? (
                <>
                  <div className={`${activityData.schedule.recurring?.addPadding ? 'col' : 'col-md-3'} pt-3`}>
                    <div className='details-label'>Start Time</div>
                    {scheduleValue?.timeSlots?.map((slot, index) => (
                      <div key={`start-${index}`} className='details-value mb-2 pt-1'>
                        {moment(slot?.startTime, 'HH:mm')?.format('hh:mm A')}
                      </div>
                    ))}
                  </div>
                  <div className={`${activityData.schedule.recurring?.addPadding ? 'col' : 'col-md-3'} pt-3`}>
                    <div className='details-label'>End Time</div>
                    {scheduleValue?.timeSlots?.map((slot, index) => (
                      <div key={`end-${index}`} className='details-value mb-2 pt-1'>
                        {moment(slot?.endTime, 'HH:mm')?.format('hh:mm A')}
                      </div>
                    ))}
                  </div>
                  {activityData.schedule.recurring?.addPadding && (
                    <>
                      <div className='col pt-3'>
                        <div className='details-label'>Padding Duration</div>
                        {scheduleValue.timeSlots.map((slot, i) => (
                          <div key={`pd-${i}`} className='details-value mb-2 pt-1'>
                            {i === scheduleValue.timeSlots.length - 1 || !+slot.paddingDuration
                              ? '—'
                              : `${slot.paddingDuration} minutes`}
                          </div>
                        ))}
                      </div>
                      <div className='col pt-3'>
                        <div className='details-label'>Slot Capacity</div>
                        {scheduleValue.timeSlots.map((slot, i) => (
                          <div key={`cap-${i}`} className='details-value mb-2 pt-1'>
                            {slot.capacity === null || slot.capacity === undefined
                              ? '---'
                              : slot.capacity}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                  {activityData?.schedule?.scheduleType === 'RECURRING' && (
                    <>
                      <div className={`${activityData.schedule.recurring?.addPadding ? 'col' : 'col-md-3'} pt-3`}>
                        <div className='details-label'>Gender</div>
                        {scheduleValue?.timeSlots?.map((slot, index) => (
                          <div key={`gender-${index}`} className='details-value mb-2 pt-1'>
                            {slot?.gender || 'All'}
                          </div>
                        ))}
                      </div>
                      <div className={`${activityData.schedule.recurring?.addPadding ? 'col' : 'col-md-3'} pt-3`}>
                        <div className='details-label'>Audience Type</div>
                        {scheduleValue?.timeSlots?.map((slot, index) => (
                          <div key={`audience-${index}`} className='details-value mb-2 pt-1'>
                            {AUDIENCE_TYPE_OPTIONS.find((o) => o.id === slot?.audienceType)?.name || slot?.audienceType || 'All'}
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div className='col-12'>
                  <div className='details-value'>--</div>
                </div>
              )}
            </div>
          )}
        </>
      )}
      {tabValue === 3 && (
        <>
          {activityData?.waiver?.status ? (
            <>
              <div className='col-md-12 mt-4'>
                <div className='details-label mb-1'>Message Text</div>
                <div className='details-value mt-1'>
                  {activityData?.waiver?.messageText || EMPTY_PLACEHOLDER}
                </div>
              </div>
              <div className='col-md-12 mt-4'>
                <div className='details-label mb-1'>Checkbox Label</div>
                {activityData?.waiver?.checkboxes?.length > 0 ? (
                  activityData?.waiver?.checkboxes?.map((checkbox, index) => (
                    <div key={index} className='details-value mt-2'>
                      {checkbox?.label}
                    </div>
                  ))
                ) : (
                  <div className='details-value'>{EMPTY_PLACEHOLDER}</div>
                )}
              </div>
            </>
          ) : (
            <p className='details-value'>No Data Available</p>
          )}
        </>
      )}
      {tabValue === 4 && (
        <>
          {activityData?.information && activityData?.information.length > 0 ? (
            <div className='row mt-4 mb-2'>
              <div className='col-md-8'>
                {activityData?.information?.map((information, ndx) => (
                  <div key={ndx}>
                    <div className='details-label'>
                      {information?.title} - {information?.displayTitle}
                    </div>
                    <div className='details-value'>
                      <p>{setInfoView(information)}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          ) : (
            <p className='details-value'>No Data Available</p>
          )}
        </>
      )}
      {tabValue === 5 && (
        <>
          <div className='col-md-6 mt-4'>
            <div className='details-label'>CTA Status</div>
            <div className='details-value'>
              {activityData?.cta?.status ? 'Active' : 'Inactive'}
            </div>
          </div>
          {activityData?.cta?.status && (
            <>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>CTA Type</div>
                <div className='details-value'>
                  {activityData?.cta?.type === 'Enquire'
                    ? 'Enquire'
                    : activityData?.cta?.type === 'Book'
                    ? 'Book'
                    : activityData?.cta?.type || EMPTY_PLACEHOLDER}
                </div>
              </div>
              <div className='col-md-6 mt-4'>
                <div className='details-label'>CTA Display Title</div>
                <div className='details-value'>
                  {activityData?.cta?.title || EMPTY_PLACEHOLDER}
                </div>
              </div>
              {activityData?.cta?.type === 'Enquire' && (
                <>
                  {activityData?.cta?.email && (
                    <div className='col-md-6 mt-4'>
                      <div className='details-label'>Email</div>
                      <div className='details-value'>{activityData?.cta?.email}</div>
                    </div>
                  )}
                  {activityData?.cta?.phoneNumber && (
                    <div className='col-md-6 mt-4'>
                      <div className='details-label'>Phone Number</div>
                      <div className='details-value'>
                        <CustomPhoneNoView value={activityData?.cta?.phoneNumber} />
                      </div>
                    </div>
                  )}
                </>
              )}
            </>
          )}
        </>
      )}
      {tabValue === 6 &&
        (activityData?.bannerImageStatus === true ? (
          <>
            <div className='col-md-12 m-3'>
              <h4 className='custom-image-viewer-title'>Banner type</h4>
              <div className='details-value'>
                {activityData?.bannerImage?.fileName
                  ? 'Image'
                  : activityData?.label
                  ? 'Label'
                  : 'Image'}
              </div>
            </div>
            <div className='col-md-12'>
              {activityData?.bannerImage?.fileName ? (
                <CustomImageViewer
                  images={[activityData?.bannerImage]}
                  isLabelHidden={false}
                  imageType={activityData?.label}
                />
              ) : (
                <>
                  {activityData?.label ? (
                    <>
                      <div className='details-label mx-3'>Label HEX Code</div>
                      <div className='details-value d-flex align-items-center mx-3 pt-2'>
                        <div
                          className='showColorPrview'
                          style={{ backgroundColor: activityData?.label }}
                        ></div>
                        {activityData?.label}
                      </div>
                    </>
                  ) : (
                    <>
                      <h4 className='custom-image-viewer-title px-3'>Banner Image</h4>
                      <div className='details-value mx-3'>0 Images</div>
                    </>
                  )}
                </>
              )}
            </div>
          </>
        ) : (
          <p className='details-value'>No Data Available</p>
        ))}

      {tabValue === 7 && (
        <MediaViewer
          images={activityData.images}
          videos={activityData.videos}
          gifs={activityData.gifs}
          enabledMediaTabs={['image']}
        />
      )}
    </div>
  );
};

export default ActivityCalendarCetails;
